module.exports = __webpack_public_path__ + "img/AH.a762540d.png";